import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { Fields, validateProperty, validate, Card } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import services from '../services';
import MenuItem from '@material-ui/core/MenuItem';
import { transactionSyncSchemaObject } from '../transactionSyncSchema';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import Joi from '@hapi/joi'
import { TextField } from '@material-ui/core';
import FormHelperText from '@material-ui/core/FormHelperText';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const screenCode = 'SYNCTRANSACTIONNS'
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function Listing(props) {
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [searchData, setSearchData] = useState({
        groupID: 0,
        operationEntityID: 0,
        transactionTypeID: 0,
        divisionID: 0,
        fromDate: '',
        toDate: ''

    });
    const [groups, setGroups] = useState()
    const [estates, setEstates] = useState()
    const [divisions, setDivisions] = useState()
    const [isTableHide, setIsTableHide] = useState(true);
    const [errors, setErrors] = useState({});
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const schema = Joi.object(transactionSyncSchemaObject).options({ allowUnknown: true });
    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getDivisions()
        )
    }, [searchData.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSYNCTRANSACTIONS');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITSYNCTRANSACTIONS');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        getAllGroups();
    }

    async function getDivisions() {
        const result = await services.getDivisions(searchData.operationEntityID)
        setDivisions(result)
    }

    async function getEstates() {
        var data = await services.getEstatesByGroupID(searchData.groupID);
        setEstates(data)
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }
    async function handleSearch(e) {
        var model = {
            operationEntityID: parseInt(searchData.operationEntityID),
            divisionID: parseInt(searchData.divisionID),
            transactionTypeID: parseInt(searchData.transactionTypeID),
            fromDate: searchData.fromDate,
            toDate: searchData.toDate
        };
        const data = await services.getSyncedData(model);
        if (data.length > 0) {
            setIsTableHide(false);
        }
        setData(data);
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setSearchData({
            ...searchData,
            groupID: target.value,
            operationEntityID: '0',
            divisionID: '0'
        })
    }

    function handleEstateChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            operationEntityID: target.value,
            divisionID: '0'
        })
    }

     function handleTransactionType(target) {
        validateInputs(target);

        setSearchData({
            ...searchData,
            transactionTypeID: target.value,
        });
    }


      function handleCollectionPointDropdown(target) {
        console.log("target value", target.value);
        if (searchData.transactionTypeID == '4') {
            console.log("In bought leaf");
            setSearchData({
                ...searchData,
                divisionID: target.value,

            });
        }
        else {
            console.log("Out bought leaf");
            validateInputs(target);

            setSearchData({
                ...searchData,
                divisionID: target.value,

            });
        }

    }
    function handleFromDate(target) {
        validateInputs(target);

        setSearchData({
            ...searchData,
            fromDate: target.value,
        });
    }

    function handleToDate(target) {
        validateInputs(target);

        setSearchData({
            ...searchData,
            toDate: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, transactionSyncSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)

    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setSearchData({
            ...searchData,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            transactionTypeID: '0',
            fromDate: '',
            toDate: '',
            divisionID: '0'
        });
        setData([]);
        setIsTableHide(true);
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Transaction Synchronization"
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    buttonText="Sync Transaction"
                                    path="syncTransaction/addEdit" />
                            </div>
                            <hr />

                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                 <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={searchData.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={searchData.operationEntityID}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="transactionTypeID">Transaction Type *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="transactionTypeID"
                                            id="transactionTypeID"
                                            name="transactionTypeID"
                                            value={searchData.transactionTypeID}
                                            onChange={(e) => handleTransactionType(e.target)}
                                        >
                                            <MenuItem value="0">--Transaction Type--</MenuItem>
                                            <MenuItem value="1">Checkroll</MenuItem>
                                            <MenuItem value="2">Overtime</MenuItem>
                                            <MenuItem value="3">Outgrower</MenuItem>
                                            <MenuItem value="4">Bought Leaf</MenuItem>

                                        </Select>
                                        {errors["transactionTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["transactionTypeID"]}</FormHelperText>}
                                    </div>

                                </div>
                                <div className="form-group row">
                                    {searchData.transactionTypeID != '4' ?
                                    <div className="col-md">
                                        <InputLabel shrink id="divisionID">Division *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={searchData.divisionID}
                                            onChange={(e) => handleCollectionPointDropdown(e.target)}
                                            disabled={!permissionList.isOperationEntityFilterEnabled || searchData.transactionTypeID == '4'}
                                        >
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>}
                                    </div>
                                    : null}  
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="fromDate"> From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDate(e.target)}
                                            value={searchData.fromDate}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>}

                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="toDate"> To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDate(e.target)}
                                            value={searchData.toDate}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>}

                                    </div>

                                </div>
                                <div className="form-group row">
                                </div>
                                <div className="card-footer">
                                    <input

                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={(e) => trackPromise(handleSearch(e))}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />

                                </div>

                            </form>

                            <div className="table-responsive row-top-gap" >
                                {data.length > 0 ?
                                    <div>
                                        <TableContainer component={Paper}>
                                            <Table className={classes.table} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="left" style={{ fontWeight: "bold" }}>Synced Date</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold" }}>Synced Time</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold" }}>Transaction Type</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold" }}>Transaction Date</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold" }}>Estate Code</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold" }}>Estate Name</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold" }}>Division Code</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold" }}>Division Name</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold" }}>Synced By</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {data.slice(page * limit, page * limit + limit).map((row, i) => (
                                                        <TableRow key={i}>
                                                            <TableCell component="th" scope="row" align="left"> {moment(row.createdDate).format('MM/DD/YYYY')}</TableCell>
                                                            <TableCell component="th" scope="row" align="left"> {moment(row.createdDate).format('hh:mm A')}</TableCell>
                                                            <TableCell component="th" scope="row" align="left"> {row.transactionType}</TableCell>
                                                            <TableCell component="th" scope="row" align="left"> {moment(row.syncedDate).format('MM/DD/YYYY')}</TableCell>
                                                            <TableCell component="th" scope="row" align="left"> {row.bplEstateID}</TableCell>
                                                            <TableCell component="th" scope="row" align="left"> {row.operationEntityName}</TableCell>
                                                            <TableCell component="th" scope="row" align="left"> {row.bplDivisionID}</TableCell>
                                                            <TableCell component="th" scope="row" align="left"> {row.operationEntityName}</TableCell>
                                                            <TableCell component="th" scope="row" align="left"> {row.firstName}</TableCell>
                                                        </TableRow>
                                                    )
                                                    )}

                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                component="div"
                                                count={data.length}
                                                onChangePage={handlePageChange}
                                                onChangeRowsPerPage={handleLimitChange}
                                                page={page}
                                                rowsPerPage={limit}
                                                rowsPerPageOptions={[5, 10, 25]}
                                            />
                                        </TableContainer>
                                    </div>
                                    : null}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}